<!-- @format -->

<template>
    <div
        v-toggle="!$vuetify.breakpoint.mdAndUp"
        class="gst-event-sidebar__footer">
        <EventTotalsContainer
            :title="title"
            :event="event"
            :bundle-products="bundleProducts" />
    </div>
</template>

<script>
import toggleNudge from '@tenant/app/directives/toggleButtonNudge.js';
import EventTotalsContainer from '../EventTotalsContainer.vue';

export default {
    name: 'EventSidebarFooter',
    components: {
        EventTotalsContainer,
    },
    directives: {
        toggle: toggleNudge,
    },
    props: {
        title: {
            type: String,
            default: null,
        },
        bundleProducts: {
            type: Object,
            default: null,
        },
        event: {
            type: Object,
            required: true,
        },
    },
};
</script>
